<template>
    <div class="container">
         <div class="menu-content">
            <!-- 菜单栏 -->
            <div class="menuBtn">
                <el-tree class="el-menu-vertical-demo" :data="tableData" :props="defaultProps" :default-expand-all="true" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
            </div>
            <!-- 菜单栏内容 -->
            <div class="manage">
                <div class="btn">
                    <el-button type="primary" size="small" @click="oneLevelMenu" v-if="parArray.indexOf('addyimenu_oa') != -1" >添加一级菜单</el-button>
                    <!-- <el-button type='primary'>添加同级菜单</el-button> -->
                    <el-button size="small" type="primary" @click="lowerLevel" v-if="parArray.indexOf('addxia_oa') != -1">添加下级菜单</el-button>
                    <el-button size="small" type="danger" @click="delectData" v-if="parArray.indexOf('menudel_oa') != -1">删除菜单</el-button>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small"  label-width="110px" class="elForm">
                    <el-form-item label="上级菜单" prop="father_name" v-if="if_father">
                        <el-input v-model="ruleForm.father_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="菜单名称" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入菜单名称"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单链接" prop="link">
                        <el-input v-model="ruleForm.link" placeholder="请输入菜单链接"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单编码" prop="code">
                        <el-input v-model="ruleForm.code" placeholder="请输入菜单编码"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单排序" prop="sortNo">
                        <el-input type="number" style="width: 215px" v-model="ruleForm.sortNo" placeholder="请输入菜单排序"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单类型" prop="menuType">
                        <el-select v-model="ruleForm.menuType" disabled placeholder="请选择菜单类型">
                            <el-option label="菜单" value="1"></el-option>
                            <el-option label="按钮" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="系统类型" prop="systemType">
                        <el-select v-model="ruleForm.systemType" placeholder="请选择系统类型" disabled>
                            <el-option v-for="items in systemlist" :key="items.dictId" :label="items.dictName" :value="items.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="flex jcb" v-if="ruleForm.parentCode == '0'">
                        <el-form-item label="菜单图标" prop="icon" >
                            <!-- <el-input v-model="ruleForm.icon"></el-input> -->
                            <headerPicture ref="headerPicture1" @getUrl="getImage($event, 1)" :qrCodeUrl="ruleForm.icon"  />
                        </el-form-item>
                        <el-form-item label="菜单激活图标" prop="onHoverIconUrl">
                            <!-- <el-input v-model="ruleForm.icon"></el-input> -->
                            <headerPicture ref="headerPicture2" class="hover-img" @getUrl="getImage($event, 2)" :qrCodeUrl="ruleForm.onHoverIconUrl"/>
                        </el-form-item>
                    </div>
                    <el-form-item label="权限标识" prop="identification">
                        <el-input v-model="ruleForm.identification" placeholder="请输入权限标识"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单备注" prop="desc">
                        <el-input type="textarea" v-model="ruleForm.desc" placeholder="请输入菜单备注"></el-input>
                    </el-form-item>
                    <el-form-item class="btn-con">
                        <el-button size="medium" type="primary" @click="submitForm('ruleForm')" v-if="parArray.indexOf('ljcj_oa') != -1">立即创建</el-button>
                        <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!-- 管理客户等级 -->
    </div>
</template>

<script>
import headerPicture from '../../components/headerPicture.vue'
export default {
    components: { headerPicture },
    data() {
        return {
            ruleForm: {
                name: "",
                link: "",
                sortNo: "",
                menuType: "1",
                desc: "",
                icon: "",
                code: "",
                father_name: "",
                identification: "",
                systemType: "3",
                onHoverIconUrl: ''
            },

            rules: {
                name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
                link: [{ required: true, message: "请输入菜单链接", trigger: "blur" }],
                code: [{ required: true, message: "请输入菜单编码", trigger: "blur" }],
                sortNo: [
                    { required: true, message: "请输入菜单排序", trigger: "blur" },
                ],
                icon: [{ required: true, message: "请选择菜单图标", trigger: "change" }],
                onHoverIconUrl: [{ required: true, message: "请选择菜单激活图标", trigger: "change" }],
                desc: [{ required: true, message: "请填写菜单备注", trigger: "blur" }],
                // identification: [
                //   { required: true, message: '请填写菜单备注', trigger: 'blur' }
                // ]
            },
            currentPage1: 1,
            tableData: [],
            formpop: {
                list: [
                    {
                        name: "",
                        code: "",
                    },
                ],
                icon: "",
                onHoverIconUrl:"",
                link: "",
                sortNo: "",
                type: "",
            },
            formLabelWidth: "120px",
            if_delect: false,
            defaultProps: {
                children: "children",
                label: "name",
            },
            parentCode: "",
            if_father: false,
            menuId: "",
            limits: "",
            parArray: [],
            systemlist: [],
        };
    },
    created() {
        this.listAxios();
        this.systemAxios();
        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"));
        const params = this.limits.buttonTreeDto.filter(
            (item) => item.menuCode === "menu"
        );
        params[0].buttonList.forEach((item) => {
            this.parArray.push(item.code);
        });
        // 权限设定判断 normsCode
    },
    activated() {
        //  this.listAxios();
    },
    methods: {
        getImage(url, type) {
            if (type == 1) {
                this.ruleForm.icon = url;
            } else {
                this.ruleForm.onHoverIconUrl = url;

            }
        },
        // 系统下拉框字典组
        systemAxios() {
            this.axios
                .get("/sys/v1/common/win/type?groupId=win_global_type", {
                    headers: {
                        Authorization: "",
                        isLoading: false,
                    },
                })
                .then((res) => {
                    // console.log(res);
                    if (res.code == 0) {
                        this.systemlist = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 一级菜单
        oneLevelMenu() {
            this.parentCode = "";
            this.menuId = "";
            this.if_father = false;
            this.ruleForm = {
                name: "",
                link: "",
                sortNo: "",
                menuType: "1",
                desc: "",
                icon: "",
                onHoverIconUrl: '',
                code: "",
                identification: "",
                father_name: this.ruleForm.father_name,
                systemType: "3",
                parentCode: '0'
            };
        },
        // 添加下级菜单
        lowerLevel() {
            console.log('>>', this.ruleForm)
            if (!this.ruleForm.name) {
                return this.$message.error('请先选择上级菜单')
            }
            this.if_father = true;
            this.ruleForm = {
                name: "",
                link: "",
                sortNo: "",
                menuType: "1",
                desc: "",
                code: "",
                identification: "",
                father_name: this.ruleForm.father_name,
                systemType: this.ruleForm.systemType,
            };
            this.menuId = "";
        },
        //** 查询菜单列表 **//
        listAxios() {
            this.axios
                .post("/sys/v1/menu/button/tree", {
                    request: {
                        name: "",
                        winType: 3
                    },
                    version: "",
                })
                .then((res) => {
                    // console.log("查询菜单列表");
                    // console.log(res);
                    if (res.code == 0) {
                        this.tableData = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        submitForm: _.debounce(function (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.menuId == "") {
                        this.axios
                            .post("/sys/v1/menu/button/add", {
                                request: {
                                    userId: sessionStorage.getItem("user_id"),
                                    name: this.ruleForm.name,
                                    code: this.ruleForm.code,
                                    parentCode: this.parentCode,
                                    type: this.ruleForm.menuType,
                                    iconUrl: this.ruleForm.icon,
                                    jumpUrl: this.ruleForm.link,
                                    sort: this.ruleForm.sortNo,
                                    remark: this.ruleForm.desc,
                                    perms: this.ruleForm.identification,
                                    winType: this.ruleForm.systemType,
                                    onHoverIconUrl: this.ruleForm.onHoverIconUrl

                                },
                            })
                            .then((res) => {
                                console.log(res);
                                if (res.code == 0) {
                                    this.listAxios();
                                    this.$message.success("添加成功");
                                    this.if_father = false;
                                    this.menuId == "";
                                    this.ruleForm = {
                                        name: "",
                                        link: "",
                                        sortNo: "",
                                        menuType: "1",
                                        desc: "",
                                        icon: "",
                                        code: "",
                                        father_name: "",
                                        identification: "",
                                        systemType: "1",
                                        onHoverIconUrl: ''
                                    };
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                    } else {
                        // 修改按钮
                        this.axios
                            .post("/sys/v1/menu/button/update", {
                                request: {
                                    id: this.menuId,
                                    userId: sessionStorage.getItem("user_id"),
                                    name: this.ruleForm.name,
                                    code: this.ruleForm.code,
                                    parentCode: this.parentCode,
                                    type: this.ruleForm.menuType,
                                    iconUrl: this.ruleForm.icon,
                                    jumpUrl: this.ruleForm.link,
                                    sort: this.ruleForm.sortNo,
                                    remark: this.ruleForm.desc,
                                    perms: this.ruleForm.identification,
                                    winType: this.ruleForm.systemType,
                                    onHoverIconUrl: this.ruleForm.onHoverIconUrl
                                },
                            })
                            .then((res) => {
                                // console.log(res);
                                if (res.code == 0) {
                                    this.listAxios();
                                    this.$message.success("修改成功");
                                    this.if_father = false;
                                    this.menuId == "";
                                    this.ruleForm = {
                                        name: "",
                                        link: "",
                                        sortNo: "",
                                        menuType: "1",
                                        desc: "",
                                        icon: "",
                                        code: "",
                                        father_name: "",
                                        identification: "",
                                        systemType: "1",
                                        onHoverIconUrl: ''
                                    };
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        }, 300),
        //** 查询菜单列表 **//
        handleNodeClick(data) {
            console.log(data);
            this.parentCode = data.code;
            this.menuId = data.id;
            this.ruleForm = {
                father_name: data.name,
                name: data.name,
                link: data.jumpUrl,
                sortNo: data.sort,
                menuType: "1",
                desc: data.remark,
                icon: data.iconUrl,
                code: data.code,
                identification: data.perms,
                systemType: data.winType,
                onHoverIconUrl: data.onHoverIconUrl,
                parentCode: data.parentCode
            };
            if(this.ruleForm.parentCode == 0){
                this.$nextTick(() => {
                    this.$refs.headerPicture1.imageUrl = data.iconUrl;
                    this.$refs.headerPicture2.imageUrl = data.onHoverIconUrl;
                });
            }
        },
        is_null(content) {
            if (content) {
                return false;
            } else {
                return true;
            }
        },
        delectData() {
            this.$confirm("确定要删除该权限吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    if (this.menuId == "" || this.menuId == undefined) {
                        this.$message.warning("删除失败");
                    } else {
                        this.axios
                            .post(
                                "/sys/v1/menu/button/delete",
                                {
                                    request: {
                                        userId: sessionStorage.getItem("user_id"),
                                        id: this.menuId,
                                    },
                                },
                                {
                                    headers: {
                                        isloading: false,
                                    },
                                }
                            )
                            .then((res) => {
                                console.log(res);
                                if (res.code == 0) {
                                    this.$message.success("删除成功");
                                    // this.tableData.list.splice(index, 1);
                                    this.listAxios();
                                    this.parentCode = "";
                                    this.if_father = false;
                                    this.menuId = "";
                                    this.ruleForm = {
                                        name: "",
                                        link: "",
                                        sortNo: "",
                                        menuType: "1",
                                        desc: "",
                                        icon: "",
                                        code: "",
                                        father_name: "",
                                        identification: "",
                                        systemType: "1",
                                    };
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // handleCurrentChange(val) {
        // 		// console.log(`当前页: ${val}`);
        // 		this.staiffList(`${val}`);
        // },
        //删除当前行数据
        deleteRow(index, rows) {
            console.log(index);
            rows.splice(index, 1);
        },
        tomenuEditing(row) {
            this.$router.push({ name: "menuEditing", query: { id: row.id } });
        },
        handleEdit(index, row) {
            console.log(index, row);
            //row是该行tableData对应的一行
            this.form = row;
        },
        /*** 增加按钮/链接 ***/
        addContent() {
            let content = {
                name: "",
                icon: "",
            };
            this.formpop.list.push(content);
            if (this.formpop.list.length >= 2) {
                this.if_delect = true;
            } else {
                this.if_delect = false;
            }
        },
        /*** 增加按钮/链接 ***/

        /*** 删掉按钮/链接 ***/
        delect(index) {
            this.formpop.list.splice(index, 1);
            if (this.formpop.list.length >= 2) {
                this.if_delect = true;
            } else {
                this.if_delect = false;
            }
        },
        /*** 删掉按钮/链接 ***/
    },
};
</script>

<style scoped lang="scss">
// .div1 {
//     margin-left: -16px;
//     background: url(../../../assets/breadcrumb2.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #2d7edf;
// }

// .div2 {
//     margin-left: -16px;
//     background: url(../../../assets/breadcrumb1.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #fff;
// }

// .div3 {
//     margin-left: -8px;
//     background: url(../../../assets/breadcrumb3.png);
//     width: 120px;
//     height: 30px;
//     text-align: center;
//     line-height: 30px;
//     color: #2d7edf;
// }
 .menu-content{
    display: flex;
    // padding-top: 16px;
 }
.el-menu-vertical-demo {
    margin-right: 16px;
    width: 200px;
    // position: absolute;
    // left: 0;
    height: calc(100vh - 136px);
    overflow-y: auto;
    border-radius: 8px;
    padding: 16px;
    box-sizing: border-box;
    /deep/.el-tree-node__content{
        height: 28px;
    }
}

.elForm {
    padding: 20px 0 0;
    max-width: 500px;
    /deep/{
        .el-input__inner,
        .el-textarea__inner{ 
            padding-left: 8px;
        }
        .el-form-item__label{
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
        }
    }
    .btn-con{
        text-align: center;
        padding-top: 10px;
    }
}

.formBox {
    z-index: 10000;
    position: relative;
}

.header {
    font-size: 16px;
    color: #2d7edf;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.demo-form-inline {
    margin-top: 10px;
}

// /deep/.el-input__inner {
//     height: 30px;
//     line-height: 30px;
// }

.manage {
    padding: 32px 16px 16px 16px;
    background: #fff;
    // position: absolute;
    // top: 37px;
    // left: 216px;
    box-sizing: border-box;
    height: calc(100vh - 136px);
    border-radius: 8px;
    // width: calc(100vw - 448px);
    flex: 1;
    .hover-img /deep/{
         .el-upload--picture-card{
            background: #00B498;
        }
        .addicon{
            color: #fff;
        }
    }
}

/deep/.has-gutter .cell {
    text-align: center;
    color: #2d7ddf;
}

/deep/.cell {
    text-align: center;
}

.name {
    font-size: 16px;
    color: #2d7edf;
    margin: 10px 0;
}

.optain {
    width: 100%;
    text-align: center;

    p {
        display: inline-block;
        vertical-align: middle;
        margin-left: 20px;

        img {
            width: 18px;
            height: 20px;
            margin-top: 8px;
        }
    }
}

.item {
    display: inline-block;
    margin-left: 10px;
    position: relative;

    img {
        width: 22px;
        height: 22px;
    }
}

.pover {
    display: inline-block;

    /deep/.el-button {
        padding: 8px;
    }
}

/deep/.el-form-item {
    // margin-bottom:0px;
}


/deep/.el-popover__title {
    font-size: 15px;
    color: #666;
}

.float {
    padding: 8px 10px !important;
}

.page {
    margin: 20px 0;
    text-align: right;
    width: 100%;

    span {
        font-size: 15px;
        color: #888;
        display: inline-block;
        margin-left: 10px;
        margin-top: -2px;
        vertical-align: middle;
    }

    .el-pagination {
        display: inline-block;
        vertical-align: middle;
    }
}

/deep/.el-table__row:hover {
    color: rgb(45, 125, 223);
}

/deep/.el-dialog {
    width: 55%;

    .el-input__inner {
        width: 50%;
    }
}

.add_btn {
    margin-bottom: 20px;

    /deep/.el-input__inner {
        width: 200px;
    }

    .el-form-item,
    .box {
        display: inline-block;
        vertical-align: middle;
        // width:300px;
    }

    img {
        display: inline-block;
        vertical-align: middle;
        margin-left: 20px;
        width: 22px;
        height: 22px;
    }

    p {
        display: inline-block;
        padding-top: 5px;
    }

    .delect {
        display: inline-block;

        // padding-top:10px;
        img {
            width: 23px;
            height: 23px;
        }
    }
}

.btn {
    width: 100%;
     max-width: 500px;
    text-align: right;
    .el-button + .el-button{
        margin-left: 12px;
    }
}
</style>